import { temAcesso } from '@/shared/auth/temAcesso'

const painelPagamentosMensais = () => import('./pagamentosMensais/PainelPagamentosMensais.vue')

export default {
    path: 'pagamentosmensais',
    name: 'Painel_PagamentosMensais',
    component: painelPagamentosMensais,
    beforeEnter: (to, from, next) => {
        if (temAcesso('REL-PAGMEN-00')) {
            next()
        }
    },
    children: []
}
